module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAAg0lEQVRoge3ZsQ3AIAwAQYgyi/dfBy9DmkjpqCJHT/4aCgrr5Q76GGO2Ov0+y2YeVYO+YiCdgXQG0hlIZyCdgXQG0hlIZyCdgXQG0hlIt33g2Z7n9EqvzYyI5f0vNoj+fMnM5f32GzSQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpLsAUiwJ/UCx6hMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/allEqualQuarters.png
// module id = Z70O
// module chunks = 0